<template>
  <div>
    <v-btn v-show="!uploading && data.w9Url" icon class="mx-0" @click.native="downloadFile">
      <v-icon>
        fas fa-file-download
      </v-icon>
    </v-btn>

    <v-tooltip bottom>
      <template #activator="tool">
        <v-btn v-show="!uploading && !uploadEnd && !data.w9Url" icon class="mx-0" v-on="tool.on" @click.native="selectFile">
          <v-icon>
            fas fa-upload
          </v-icon>
        </v-btn>
      </template>
      <span>Upload W9 Form</span>
    </v-tooltip>

    <v-menu bottom offset-y>
      <v-btn v-show="!uploading && !uploadEnd && data.w9Url" slot="activator" icon class="mx-0">
        <v-icon>
          fas fa-ellipsis-h
        </v-icon>
      </v-btn>
      <v-list>
        <v-list-tile @click="selectFile">
          <v-list-tile-title>Upload New File</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="deleteFile">
          <v-list-tile-title class="red--text">
            Remove File
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <input id="files" ref="uploadInput" type="file" name="file" @change="detectFile()">
    <v-tooltip :value="uploadError" left>
      <template #activator="data">
        <v-progress-circular v-show="uploading && !uploadEnd" :rotate="-90" :value="uploadPercentage" :color="uploadError ? 'red' : 'primary'" @click="resetError">
          <v-icon v-show="uploadError" color="red">
            fas fa-times
          </v-icon>
        </v-progress-circular>
      </template>
      <span>Click to Retry</span>
    </v-tooltip>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      data: {
        type: Object,
        default: () => { },
      },
    },

    data: () => ({
      uploadError: false,
      uploadPercentage: 0,
      uploading: false,
      uploadEnd: false,
      file: null,
    }),

    methods: {
      selectFile() {
        this.$refs.uploadInput.click();
      },

      resetError() {
        if (!this.uploadError) { return; }
        this.uploading = false;
        this.uploadError = false;
      },

      async downloadFile() {
        const { data } = await axios.get(`/api/human-resources/payable-entity-tax-data/${this.data.id}/w9/download`);
        window.open(data);
      },

      async deleteFile() {
        await axios.delete(`/api/human-resources/payable-entity-tax-data/${this.data.id}/w9/delete`);
        this.$emit('getListData');
      },

      detectFile() {
        // eslint-disable-next-line
        this.file = this.$refs.uploadInput.files[0];
        this.handleSubmit();
      },

      async handleSubmit() {
        this.uploading = true;
        const formData = new FormData();
        formData.append('file', this.file, this.file.name);
        await axios.put(`/api/human-resources/payable-entity-tax-data/${this.data.id}/w9/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total), 10);
          },
        }).then(() => {
          this.$emit('getListData');
          this.$refs.uploadInput.value = '';
          this.uploading = false;
        }).catch((error) => {
          this.$refs.uploadInput.value = '';
          this.uploadError = true;
        });
      },
    },
  };
</script>

<style scoped>
  .fa-times {
    font-size: 1em;
  }

  .progress-bar {
    margin: 10px 0;
  }

  input[type="file"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
  }

  .v-progress-circular__info {
    margin-top: -1px;
  }
</style>